module.exports = __webpack_public_path__ + "static/media/bonobo.dbdfb90c.png";